import React from 'react';
import './NavRight.scss';

function NavRightTooltip({ currentNav, navTooltip }) {
  return (
    <div className="navTooltip desktop-only" ref={navTooltip}>
      <p className="navTooltip-content">{currentNav}</p>
    </div>
  );
}

export default NavRightTooltip;
